import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title:"ChatGPT-finetuning-webui",
      description:"The GUI of finetuning chatgpt.",
      skill:"next.js GPT",
      category: "AI-LLMs",
      url:"https://chat-gpt-finetuning-webui-nextjs.vercel.app/finetuning",
      imgUrl:"https://user-images.githubusercontent.com/39402524/264582567-60c74a10-957f-4cb3-b3a2-0fc283c88a98.png"
    },
    {
      title:"MindmapGPT",
      description:" An app for effortless brainstorming and idea generation. Easily create mind maps that visualize your thoughts and needs. Let your creativity flow with automatic mind map generation, customization options, and collaboration features. ",
      skill:"Next.js GPT-3.5 tailwind",
      category: "AI-LLMs",
      url:"https://homerai.vercel.app/zh-TW",
      imgUrl:"https://i.imgur.com/LjbKEjx.png"
    },

    {
      title:"SoulJourney",
      description:"The Personal Growth Motivation App is here to guide you towards the path of personal growth and emotional balance.",
      skill:"Google vertex AI, palm 2, react, fastapi",
      imgUrl:"https://i.imgur.com/vEa5Vwq.png",
      category: "AI-LLMs"
    },
    {
      title:"AutoChart",
      description:"Input data about charts, and the system will automatically recognize and generate charts.",
      skill:"GPT-3.5, Nextjs, Langchain",
      imgUrl:"https://i.imgur.com/TGkXa0y.png",
      category: "AI-LLMs"
    },

    {
      title:"LabLab ai Hackthon winner - Info Insighters",
      description:"Amazing podcast platform, you can search the topic you are interesting, convert the podcast to text, query the associated segment and summarise it.  ",
      skill:"react with vite, python flask for backend connect the AI model and show the result. ",
      imgUrl:"https://i.imgur.com/SICZrcn.jpg",
      url:"https://lablab.ai/event/semantic-search-hackathon/info-insighters",
      category: "AI-LLMs"

    },
    {
      title: "Nasa Hackathon - Innovation Award",
      description: "Using various space data provided by NASA, data collect, clean, analyze and other steps, and finally make a song.",
      skill:"responsible for data clean and analyze by python",
      imgUrl: "https://i.imgur.com/tjfh7Y1.jpg",
    },

    {
      title: "Loto3",
      description: "A Telegram Web App that everyone can play in telegram with TON blockchain.",
      skill:"product design, build web app. connect to wallet and intact to smart contract from frontend",
      imgUrl: "https://i.imgur.com/3OqUVv3.jpg",
      url:"https://loto3-wja3-34mh8lnbc-shrine90459.vercel.app/",
      category: "BlockChain"

    },
    {
      title: "Project Peace",
      description: "Project Peace is a Multilingual Text Detoxifier. It is an innovative solution to identify and neutralize toxic or harmful language in written text.",
      skill:"brainstorm, product design, product research",
      imgUrl: "https://i.imgur.com/lHws8Z4.jpg",
      url:"https://lablab.ai/event/cohere-hackathon/project-peace/project-peace",
      category: "AI-LLMs"

    },
    {
      title: "Mutation Diary Lab",
      description: "NFT project, follow the team from design LOGO to theme background planning marketing operation community management ",
      skill:"responsible for web page, smart contract, connect wallet and call the contract",
      imgUrl: "https://i.imgur.com/YvzyWZu.png",
      category: "BlockChain"

    },

    {
      title: "SideProjectLife",
      description: "A platform that helps engineers, uiux, PM, students and other people from all walks of life to match people who want to do projects together.",
      skill:"Frontend:React,redux Backend:Spring-boot+PostgreSQL Management Tool:Github,Trello deploy to GCP using Docker Mainly responsible for the frontend and project management",
      imgUrl: "https://i.imgur.com/o23iF4g.png",
      url:"https://sideproject-life.netlify.app/"
    },
    {
      title: "MapleTrade",
      description: "Online game trading platform, helping people quickly buy and sell their own virtual treasures",
      skill:"Frontend:Next.js+tailwind+Context API Backend:Next.js+mongoDB",
      imgUrl: "https://i.imgur.com/3u7xFRb.jpg",
      url:"https://www.maplefreemarket.com/"
    },
    {
      title:"Collection Day",
      description:"Complete specified tasks in life to get NFT，It seems to bring the virtual world closer to reality",
      skill:"responsible for web page, demand analysis, wireframe, user story ",
      imgUrl:"https://i.imgur.com/ibOUEiT.png",
      url:"https://collectiond.netlify.app/",
      category: "BlockChain"

    },
    {
      title:"AssemblyHackthon - NOTE-AI",
      description:"Note AI is a cutting-edge project that uses artificial intelligence to help you take better notes. ",
      skill:"Frontend and Backend, connect the transcription api and image generation api",
      imgUrl:"https://i.imgur.com/Fayzs46.jpg",
      url:"https://github.com/yztracker/The-AI-Note-Taking-Revolution",
      category: "AI-LLMs"

    },
    {
      title:"MCU House",
      description:"Mcu House help everyone find their ideal house. ",
      skill:"University graduation topic, first complete project. Using html+css+js frontend and express+mongodb for backend",
      imgUrl:"https://i.imgur.com/TOTDuDq.png",
    },
    {
      title:"EzLaw",
      description:"Do some research about LLMs in Legal Tech, it can summary the legal information and generate the chart.  ",
      skill:"ChatGPT, react",
      imgUrl:"https://i.imgur.com/Hyp3oy3.png",
      category: "AI-LLMs"
    },
    // {
    //   title:"Find.io",
    //   description:"Do some research about LLMs in Legal Tech, it can summary the legal information and generate the chart.  ",
    //   skill:"cohere llms, qdrant vector db, discord bot",
    //   imgUrl:"https://i.imgur.com/Hyp3oy3.png",
    //   category: "AI-LLMs"
    // },
    {
      title:"Find.io",
      description:"A discord chatbot that can search message by Multilingual Semantic Search.  ",
      skill:"cohere llms, qdrant vector db, discord bot",
      imgUrl:"https://i.imgur.com/DDJgV90.png",
      category: "AI-LLMs"
    },
    {
      title:"LawsSeacher",
      description:"A semantic search for legal related, search file and test mulitiple embedding model",
      skill:"Chroma vector db, embedding model",
      imgUrl:"https://i.imgur.com/DDJgV90.png",
      category: "AI-LLMs"
    },
    

  ];

  const aiProjects = projects.filter(project => project.category === "AI-LLMs");
  const blockchainProjects = projects.filter(project => project.category === "BlockChain");
  const otherProjects = projects.filter(project => project.category !== "AI-LLMs" && project.category !== "BlockChain");

  const practice = [
    {
      title:"Covid-19",
      description:"Covid-19 data visualization",
      skill:"practice some chart and api connect",
      imgUrl:"https://i.imgur.com/SbtRFbK.jpg"
    },
    {
      title:"Movie trailer",
      description:"Movie trailer",
      skill:"connect imdb api to show the movie and get the trailer",
      imgUrl:"https://i.imgur.com/L6TNvXe.jpg"
    },
    {
      title:"Buy me a coffee",
      description:"Buy me a coffee web3 version, easy connect and pay your eth.",
      skill:"react, solidity, ETH ",
      imgUrl:"https://i.imgur.com/1H3Jmy3.jpg"
    },

  ]
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>I like to build everything that is creative and interesting
                    from idea to product.</p>
                    <p>(hover the image to get the description)</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Practice</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="third">Web3</Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                    <div className="category-label">AI-LLMs</div>
                    <Row>
                      {
                        aiProjects.map((project, index) => (
                          <ProjectCard
                            key={index}
                            {...project}
                          />
                        ))
                      }
                    </Row>
                    <div className="category-label">BlockChain</div>

                      <Row>
                        {
                          blockchainProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>

                    <div className="category-label">Project</div>

                      <Row>
                        {
                          otherProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          practice.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
